import { RiskMatrixPanel } from "@/components/assessment/results/RiskMatrixPanel";
import { ValueChainRiskPanel } from "@/components/assessment/results/ValueChainRiskPanel";
import type { ReportModel } from "@/lib/report";
import { HorizonLabel, SectionHeading } from "./ReportPage";

/**
 * Per horizon, stacked: the Exposure × Vulnerability matrix and the value-chain
 * share panel. The hazard-share chart is the per-hazard table in the summary;
 * no gauges, and no ResponsiveContainer (so nothing to measure at print time).
 */
export function ReportGraphs({ model }: { model: ReportModel }) {
  return (
    // Block + margin spacing for the same fragmentation reason as ReportSummary.
    <div className="space-y-6">
      <SectionHeading>Risk distribution</SectionHeading>
      {model.sections.map((s) => (
        <div key={s.horizon} className="break-inside-avoid space-y-4">
          {model.sections.length > 1 && <HorizonLabel>{s.label}</HorizonLabel>}
          <RiskMatrixPanel results={s.results} assets={model.assets} />
          <ValueChainRiskPanel assets={model.assets} stages={model.stages} results={s.results} />
        </div>
      ))}
    </div>
  );
}
